export default function GitHub_Flow() {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-4">GitHub Flow</h1>

      <p className="mt-4 text-gray-500 text-sm">Path: /git/github/flow</p>
    </div>
  );
}
